<template>
  <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    <template slot="topSelectMenus" slot-scope="props">
      <div class="main-table-txt" style="line-height: 40px;color: gray;">备注：默认统计日期范围为近一个月</div>
    </template>
  </grid>
</template>

<script>
import Grid from '../../../components/grid/grid'
import GridTableTh from '../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../components/grid-menu/grid-top-menu'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid
  },
  name: 'biz-stats-tip',
  data() {
    return {
      gridConfigUrl: '',
      dialogVisible: false,
      content: '',
      detailTitle: '',
      operationTip: '查看详情'
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/biz-stats-tip.vue